// import React, { useState, useEffect, useRef } from 'react';
// import './chat.css';

// export default function ChatWidget() {
//   const [messages, setMessages] = useState([]);
//   const [userInput, setUserInput] = useState('');
//   const [isTyping, setIsTyping] = useState(false);
//   const chatEndRef = useRef(null);

//   // مکالمه از پیش تعریف‌شده
//   const scriptedChat = [
//     { from: 'user', text: 'سلام. من دنبال رنگ قرمز این کفش هستم' },

//     { from: 'bot', text: 'سلام. بله حتما لطفا بگید چه سایزی ؟' },

//     { from: 'user', text: 'سایز ۳۸' },
//     {
//       from: 'bot',
//       text: 'بله حتما. ما تو سایناچرم سایز ۳۹ این کفش رو به رنگ قرمز موجود داریم و برای سایز ۳۸ رنگ طوسی موجود. ایا میخای به محض موجود شدن رنگ مد نظر بهتون اطلاع بدم؟',
//     },

//     { from: 'user', text: 'بله حتما' },
//     { from: 'bot', text: 'پس لطفا شماره موبایلتون رو برام تایپ کنید' },

//     { from: 'user', text: '۰۹۱۲۲۲۷۰۱۱۴' },
//     {
//       from: 'bot',
//       text: 'مرسی. من براتون یک کد تایید فرستادم. لطفا کد رو برام اینجا ارسال کنید',
//     },

//     { from: 'user', text: '۱۲۳۴' },
//     {
//       from: 'bot',
//       text: 'ممنون. شماره شما ثبت شد. لطفا نام خودتون رو بفرمایید',
//     },

//     { from: 'user', text: 'سارا کتابی' },
//     {
//       from: 'bot',
//       text: 'ممنون سارا جان. به محض موجود شدن برات پیامک ارسال میشه.',
//     },

//     { from: 'user', text: 'من یه کمربند چرم هم میخاستم.' },
//     { from: 'bot', text: 'بله حتما چه مدل و سایزی مد نظرتونه؟' },

//     {
//       from: 'user',
//       text: 'کمربند مردانه با کد Y4000',
//     },
//     {
//       from: 'bot',
//       text: 'از این کار رنگ سرمه ای و مشکی موجوده. چه سایزی مد نظرتونه؟',
//       type: 'linkPreview',
//       link: {
//         title: 'کمربند مردانه مدل Y4000',
//         image:
//           'https://sainacharm.com/wp-content/uploads/2024/09/%DA%A9%D9%85%D8%B1%D8%A8%D9%86%D8%AF4000.webp',
//         url: 'https://sainacharm.com/product/%da%a9%d9%85%d8%b1%d8%a8%d9%86%d8%af-%d9%85%d8%b1%d8%af%d8%a7%d9%86%d9%87-%d9%85%d8%af%d9%84-y4000/',
//       },
//     },

//     { from: 'user', text: 'سایز ۴۰' },
//     { from: 'bot', text: 'بله موجوده. میخای به نام خودت برات ثبت سفارش کنم؟' },

//     { from: 'user', text: 'بله حتما' },
//     { from: 'bot', text: 'لطفا کمی صبر کن...' },
//     { from: 'bot', text: 'سفارش شما در سایت ثبت شد.' },
//     {
//       from: 'bot',
//       text: 'لطفا روی این لینک کلیک کن و بعد از ثبت ادرس و تایید اطلاعات روی دکمه پرداخت کلیک کن:',
//     },
//     {
//       from: 'bot',

//       type: 'payment',
//     },
//   ]; // SVG components
//   const BotSVG = ({ size = 36 }) => (
//     <svg
//       width={size}
//       height={size}
//       viewBox="0 0 24 24"
//       fill="none"
//       aria-hidden
//       xmlns="http://www.w3.org/2000/svg">
//       <rect x="3" y="4" width="18" height="12" rx="2" fill="#517da2" />
//       <circle cx="8.5" cy="9" r="1.1" fill="#fff" />
//       <circle cx="15.5" cy="9" r="1.1" fill="#fff" />
//       <path
//         d="M8 14c1 1 3 1 4 0"
//         stroke="#fff"
//         strokeWidth="1.2"
//         strokeLinecap="round"
//       />
//       <rect x="7" y="1.5" width="10" height="2" rx="1" fill="#517da2" />
//     </svg>
//   );

//   const UserSVG = ({ size = 36 }) => (
//     <svg
//       width={size}
//       height={size}
//       viewBox="0 0 24 24"
//       fill="none"
//       aria-hidden
//       xmlns="http://www.w3.org/2000/svg">
//       <circle cx="12" cy="8" r="3.2" fill="#2fa3e6" />
//       <path d="M4 19c0-3.3 2.7-6 6-6h4c3.3 0 6 2.7 6 6" fill="#2fa3e6" />
//     </svg>
//   );

//   // اسکرول خودکار به پایین
//   useEffect(() => {
//     chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//   }, [messages]);

//   // اجرای مرحله‌ای مکالمه
//   //   useEffect(() => {
//   //     let index = 0;

//   //     const playScript = () => {
//   //       if (index >= scriptedChat.length) return;

//   //       const msg = scriptedChat[index];

//   //       if (msg.from === 'bot') {
//   //         setIsTyping(true);
//   //         const delay = 1000 + Math.random() * 1500;

//   //         setTimeout(() => {
//   //           setIsTyping(false);
//   //           setMessages((m) => [...m, msg]);
//   //           index++;
//   //           setTimeout(playScript, 700);
//   //         }, delay);
//   //       } else {
//   //         // پیام کاربر فوری اضافه می‌شود
//   //         setMessages((m) => [...m, msg]);
//   //         index++;
//   //         setTimeout(playScript, 700);
//   //       }
//   //     };

//   //     playScript();
//   //   }, []);
//   useEffect(() => {
//     let isMounted = true;

//     const delay = (ms) => new Promise((res) => setTimeout(res, ms));

//     const playScript = async () => {
//       for (let msg of scriptedChat) {
//         if (!isMounted) break;

//         if (msg.from === 'bot') {
//           setIsTyping(true);
//           await delay(1000 + Math.random() * 1500);
//           setIsTyping(false);
//         }

//         setMessages((m) => [...m, msg]);
//         await delay(700); // فاصله بین پیام‌ها
//       }
//     };

//     playScript();

//     return () => {
//       isMounted = false;
//     };
//   }, []);
//   const chatEndScroll = () => {
//     chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//   };

//   useEffect(() => {
//     chatEndScroll();
//   }, [messages, isTyping]);

//   const sendUserMessage = (text) => {
//     if (!text) return;
//     setMessages((m) => [...m, { from: 'user', text }]);
//     setUserInput('');

//     // پاسخ بعدی ربات
//     if (scriptIndex < scriptedChat.length) {
//       const nextIndex = scriptIndex + 1;
//       setScriptIndex(nextIndex);
//       const nextBot = scriptedChat[nextIndex];
//       if (nextBot && nextBot.from === 'bot') {
//         setIsTyping(true);
//         setTimeout(() => {
//           setMessages((m) => [...m, nextBot]);
//           setIsTyping(false);
//         }, 1200 + Math.random() * 1000);
//       }
//     }
//   };

//   return (
//     <div className="chat-widget">
//       <div className="chat-header">پشتیبان ساینا چرم</div>

//       <div className="chat-body">
//         {messages.map((m, i) => (
//           <div key={i} className={`msg-row ${m.from}`}>
//             {m.from === 'bot' ? <BotSVG /> : <UserSVG />}
//             <div className="msg-bubble">
//               {m.type === 'linkPreview' ? (
//                 <div className="preview-box">
//                   <img src={m.link.image} alt="" />
//                   <div className="preview-title">{m.link.title}</div>
//                   <a href={m.link.url} target="_blank" rel="noreferrer">
//                     مشاهده محصول
//                   </a>
//                 </div>
//               ) : m.type === 'payment' ? (
//                 <button className="pay-btn">پرداخت سفارش</button>
//               ) : (
//                 <div className="msg-text">{m.text}</div>
//               )}
//             </div>
//           </div>
//         ))}

//         {isTyping && (
//           <div className="msg-row bot">
//             <BotSVG />
//             <div className="msg-bubble typing">...</div>
//           </div>
//         )}

//         <div ref={chatEndRef} />
//       </div>

//       {/* باکس ورودی کاربر */}
//       <div className="chat-input">
//         <input
//           type="text"
//           value={userInput}
//           placeholder="پیام خود را تایپ کنید..."
//           onChange={(e) => setUserInput(e.target.value)}
//           onKeyDown={(e) => {
//             if (e.key === 'Enter') sendUserMessage(userInput.trim());
//           }}
//         />
//         <button onClick={() => sendUserMessage(userInput.trim())}>ارسال</button>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect, useRef } from 'react';
import './chat.css';

export default function ChatWidget() {
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [scriptIndex, setScriptIndex] = useState(0);
  const chatEndRef = useRef(null);

  const scriptedChat = [
    { from: 'bot', text: 'سلام! به پشتیبان ساینا چرم خوش آمدید.' },
    { from: 'user', text: 'سلام. من دنبال رنگ قرمز این کفش هستم' },
    { from: 'bot', text: 'سلام. بله حتما لطفا بگید چه سایزی ؟' },
    { from: 'user', text: 'سایز ۳۸' },
    {
      from: 'bot',
      text: 'ما سایز ۳۹ این کفش به رنگ قرمز موجود داریم و برای سایز ۳۸ رنگ طوسی موجود است. آیا می‌خواید به محض موجود شدن رنگ مد نظر، به شما اطلاع بدهم؟',
    },
    { from: 'user', text: 'بله حتما' },
    { from: 'bot', text: 'لطفا شماره موبایلتون را وارد کنید.' },
    { from: 'user', text: '۰۹۱۲۲۲۷۰۱۱۴' },
    {
      from: 'bot',
      text: 'مرسی. یک کد تایید برای شما ارسال شد، لطفا کد را وارد کنید.',
    },
    { from: 'user', text: '۱۲۳۴' },
    { from: 'bot', text: 'شماره شما ثبت شد. لطفا نام خود را وارد کنید.' },
    { from: 'user', text: 'سارا کتابی' },
    {
      from: 'bot',
      text: 'ممنون سارا جان. به محض موجود شدن پیامک ارسال خواهد شد.',
    },
    { from: 'user', text: 'من یه کمربند چرم هم می‌خواستم.' },
    { from: 'bot', text: 'چه مدلی و چه سایزی مد نظرتونه؟' },
    {
      from: 'user',
      text: 'کمربند مردانه مدل Y4000',
    },
    {
      from: 'bot',
      text: 'از این کار رنگ سرمه‌ای و مشکی موجود است. چه سایزی مد نظرتونه؟',
      type: 'linkPreview',
      link: {
        title: 'کمربند مردانه مدل Y4000',
        image:
          'https://sainacharm.com/wp-content/uploads/2024/09/%DA%A9%D9%85%D8%B1%D8%A8%D9%86%D8%AF4000.webp',
        url: 'https://sainacharm.com/product/%da%a9%d9%85%d8%b1%D8%a8%d9%86%d8%af-%d9%85%d8%b1%d8%af%d8%a7%d9%86%d9%87-%d9%85%d8%af%d9%84-y4000/',
      },
    },
    { from: 'user', text: 'سایز ۴۰' },
    { from: 'bot', text: 'بله موجوده. می‌خواید ثبت سفارش کنم؟' },
    { from: 'user', text: 'بله حتما' },
    { from: 'bot', text: 'لطفا کمی صبر کنید...' },
    { from: 'bot', text: 'سفارش شما در سایت ثبت شد.' },
    {
      from: 'bot',
      text: 'روی این لینک کلیک کنید و بعد از ثبت آدرس، روی دکمه پرداخت کلیک کنید:',
      type: 'payment',
    },
  ];

  const BotSVG = ({ size = 36 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="3" y="4" width="18" height="12" rx="2" fill="#517da2" />
      <circle cx="8.5" cy="9" r="1.1" fill="#fff" />
      <circle cx="15.5" cy="9" r="1.1" fill="#fff" />
      <path
        d="M8 14c1 1 3 1 4 0"
        stroke="#fff"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <rect x="7" y="1.5" width="10" height="2" rx="1" fill="#517da2" />
    </svg>
  );

  const UserSVG = ({ size = 36 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="3.2" fill="#2fa3e6" />
      <path d="M4 19c0-3.3 2.7-6 6-6h4c3.3 0 6 2.7 6 6" fill="#2fa3e6" />
    </svg>
  );

  const chatEndScroll = () => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    chatEndScroll();
  }, [messages, isTyping]);

  const sendUserMessage = (text) => {
    if (!text) return;
    setMessages((m) => [...m, { from: 'user', text }]);
    setUserInput('');
    setScriptIndex((prev) => prev + 1);

    // پاسخ بعدی ربات
    const nextBot = scriptedChat[scriptIndex + 1];
    if (nextBot && nextBot.from === 'bot') {
      setIsTyping(true);
      setTimeout(() => {
        setMessages((m) => [...m, nextBot]);
        setIsTyping(false);
      }, 1200 + Math.random() * 1000);
    }
  };

  return (
    <div className="chat-widget">
      <div className="chat-header">پشتیبان ساینا چرم</div>

      <div className="chat-body">
        {messages.map((m, i) => (
          <div key={i} className={`msg-row ${m.from}`}>
            {m.from === 'bot' ? <BotSVG /> : <UserSVG />}
            <div className="msg-bubble">
              {m.type === 'linkPreview' ? (
                <div className="preview-box">
                  <img src={m.link.image} alt="" />
                  <div className="preview-title">{m.link.title}</div>
                  <a href={m.link.url} target="_blank" rel="noreferrer">
                    مشاهده محصول
                  </a>
                </div>
              ) : m.type === 'payment' ? (
                <button className="pay-btn">پرداخت سفارش</button>
              ) : (
                <div className="msg-text">{m.text}</div>
              )}
            </div>
          </div>
        ))}

        {isTyping && (
          <div className="msg-row bot">
            <BotSVG />
            <div className="msg-bubble typing">...</div>
          </div>
        )}

        <div ref={chatEndRef} />
      </div>

      {/* باکس ورودی کاربر */}
      <div className="chat-input">
        <input
          type="text"
          value={userInput}
          placeholder="پیام خود را تایپ کنید..."
          onChange={(e) => setUserInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') sendUserMessage(userInput.trim());
          }}
        />
        <button onClick={() => sendUserMessage(userInput.trim())}>ارسال</button>
      </div>
    </div>
  );
}
